import { render } from "./DefaultMailNewUser.vue?vue&type=template&id=11799113"
import script from "./DefaultMailNewUser.vue?vue&type=script&lang=js"
export * from "./DefaultMailNewUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__